export default __webpack_public_path__ + "static/media/ico-help.113a08c7.svg";